import axios from "axios";
import { useFormik } from "formik";
import React, { useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import { activatePassword } from "../_redux/authCrud";
import * as auth from "../_redux/authRedux";

import { useParams } from "react-router-dom";

const initialValues = {
  password: "",
  changepassword: "",
};

function ActivatePassword(props) {
  console.log("aca");
  // debugger;
  // const { hasAuthToken } = props;
  // console.log(hasAuthToken);
  const { intl } = props;
  const [isRequested, setIsRequested] = useState(false);
  const ActivatePasswordSchema = Yup.object().shape({
    password: Yup.string()
      .min(
        3,
        intl.formatMessage(
          { id: "AUTH.VALIDATION.MIN_LENGTH" },
          { name: intl.formatMessage({ id: "AUTH.INPUT.PASSWORD" }), min: "3" }
        )
      )
      .max(
        50,
        intl.formatMessage(
          { id: "AUTH.VALIDATION.MAX_LENGTH" },
          { name: intl.formatMessage({ id: "AUTH.INPUT.PASSWORD" }), max: "50" }
        )
      )
      .required(
        intl.formatMessage({
          id: "VALIDATION.REQUIRED_FIELD",
        })
      ),
    changepassword: Yup.string()
      .required(
        intl.formatMessage({
          id: "VALIDATION.REQUIRED_FIELD",
        })
      )
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          intl.formatMessage({
            id: "AUTH.INPUT.PASSWORD.MATCH.FAILED",
          })
        ),
      }),
  });

  const routeParams = useParams();
  const activationToken = routeParams.activationToken;

  var passwordError;
  axios.interceptors.response.use(undefined, function axiosRetryInterceptor(
    error
  ) {
    if (error?.response?.status === 400) {
      passwordError = error.response.data;
    }
    if (error?.response?.status === 404) {
      passwordError = error.response.data;
    }
    if (error?.response?.status === 500) {
      passwordError = error.response.data;
    }

    return Promise.reject(error);
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ActivatePasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      //enableLoading();
      activatePassword(activationToken, values.password)
        .then(() => setIsRequested(true))
        .catch(() => {
          setIsRequested(false);
          setSubmitting(false);
          setStatus(passwordError);
        });
    },
  });

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-10 mb-lg-20">
            <h3 className="font-size-h1">
              <FormattedMessage id="AUTH.ACTIVATE.PASSWORD.TITLE" />
            </h3>
            <div className="text-muted font-weight-bold">
              <FormattedMessage id="AUTH.ACTIVATE.PASSWORD.SUBTITLE" />
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
            {/* begin: Password */}
            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder={intl.formatMessage({ id: "AUTH.INPUT.PASSWORD" })}
                type="password"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "password"
                )}`}
                name="password"
                {...formik.getFieldProps("password")}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.password}</div>
                </div>
              ) : null}
            </div>
            {/* end: Password */}

            {/* begin: Confirm Password */}
            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder={intl.formatMessage({
                  id: "AUTH.INPUT.CONFIRM_PASSWORD",
                })}
                type="password"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "changepassword"
                )}`}
                name="changepassword"
                {...formik.getFieldProps("changepassword")}
              />
              {formik.touched.changepassword && formik.errors.changepassword ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors.changepassword}
                  </div>
                </div>
              ) : null}
            </div>
            {/* end: Confirm Password */}
            <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting}
              >
                <FormattedMessage id="AUTH.GENERAL.SUBMIT_BUTTON" />
              </button>
              <Link to="/auth">
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                >
                  <FormattedMessage id="COMMON.GENERAL.CANCEL_BUTTON" />
                </button>
              </Link>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ActivatePassword));
